module.exports = __webpack_public_path__ + "media/src/images/balloons/HomeBanner-yellow-221599939ff7943955fb6eb83f4c0ce2.jpg";